var render, staticRenderFns
import script from "./value-or-not-available.vue?vue&type=script&lang=ts&"
export * from "./value-or-not-available.vue?vue&type=script&lang=ts&"
import style0 from "./value-or-not-available.vue?vue&type=style&index=0&id=0784fc26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0784fc26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0784fc26')) {
      api.createRecord('0784fc26', component.options)
    } else {
      api.reload('0784fc26', component.options)
    }
    
  }
}
component.options.__file = "app/component/misc/value-or-not-available.vue"
export default component.exports